import { css } from 'linaria';

export const signupBlockTitle = css`
  &&& {
    @media (--only-largeDesktop) {
      white-space: break-spaces;
    }

    @media (--to-largeDesktop) {
      font-size: 21px;
      line-height: 26px;
    }
  }
`;

export const signupBlock = css`
  display: flex;
  border-radius: var(--rounding-xl);
  background-color: var(--background-secondary);

  @media (--to-desktop) {
    flex-direction: column-reverse;
  }
`;

export const signupBlockBody = css`
  display: flex;
  flex-direction: column;
  row-gap: 32px;
  width: 50%;
  padding: 32px;
  height: fit-content;
  border-radius: var(--rounding-xl) 0 0 var(--rounding-xl);

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-mobile) {
    padding: 16px;
  }
`;

export const signupBlockVariant = css`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const signupBlockVariantItem = css`
  display: flex;
  padding: 20px;
  border-radius: var(--rounding-xl);
  background-color: var(--background-primary);
  column-gap: 12px;
  align-items: flex-start;

  @media (--only-mobile) {
    flex-direction: column;
    row-gap: 12px;
  }
`;

export const signupBlockIconWrapper = css`
  background-color: var(--background-secondary);
  padding: 10px;
  border-radius: var(--rounding-xl);
  display: flex;
`;

export const signupBlockVariantItemTitle = css`
  margin-bottom: 10px;
`;

export const signupBlockImageWrapper = css`
  width: 50%;

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-tablet) {
    height: 320px;
  }
`;

export const signupBlockImage = css`
  width: 100%;
  height: 100%;
  border-radius: var(--rounding-xl);
`;
